export enum OverviewActionNames {
  SetSelectedIndex = 'set overview selected index',
  SetSelectedDates = 'set overview selected dates',
  SetDifferecePeriod = 'set overview difference period',
  SetSelectedRooms = 'set overview selected rooms',
  ToggleSelectedRoom = 'toggle overview selected room',
  UpdateStats = 'update overview stats',
  InitiateStates = 'init overview stats',
}
